const paths = {
  chat: 'M4 5h16v11H8l-4 4V5z',
  phone:
    'M6.6 10.8a15.1 15.1 0 006.6 6.6l2.2-2.2a1 1 0 011-.25 11.4 11.4 0 003.6.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.25 1z',
  download: 'M12 3v12m0 0l-5-5m5 5l5-5M4 19h16',
  sync: 'M4 12a8 8 0 0114-5.3L20 9M20 4v5h-5M20 12a8 8 0 01-14 5.3L4 15m0 5v-5h5',
  upgrade: 'M12 20V8m0 0l-5 5m5-5l5 5M5 4h14',
  laptop: 'M5 6h14v9H5zM3 18h18',
  photo: 'M4 5h16v14H4zM4 15l5-5 4 4 3-3 4 4M15 9h.01',
  repair: 'M14.7 6.3a4 4 0 00-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 005.4-5.4l-2.5 2.5-2.5-.5-.5-2.5z',
  check: 'M5 12l5 5L20 7',
  leaf: 'M5 19c0-9 6-14 15-14 0 9-5 15-14 15M5 19l7-7',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  clock: 'M12 7v5l3 2M12 21a9 9 0 110-18 9 9 0 010 18z',
};

export default function Icon({ name, size = 22 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
